import React, {PureComponent} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import get from 'lodash/get';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ImageChoiceType from '../ImageChoiceType';
import FormGroup from '../FormGroup';
import CommonFields from './CommonFields';
import Error from '../../../Error';
import {IMAGE_RATIO_FORMATS} from '../../../../constants';
class SingleChoice4Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <FormGroup name={`${name}.ratio`} size={12} label={messages.surveys.form.label.ratio}>
                        <FastField id={`${name}.ratio`} name={`${name}.ratio`} component="select"
                            className={classNames('form-control custom-select',
                                {error: get(form.errors, `${name}.ratio`) && get(form.touched, `${name}.ratio`)})}>
                            {IMAGE_RATIO_FORMATS.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                        </FastField>
                        <ErrorMessage name={`${name}.ratio`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                </div>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.optionList} />
                    </h4>
                    <FieldArray name={`${name}.choices`} component={ImageChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default SingleChoice4Type;
